// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4321":"e3d2af9b","5026":"3fcc629e","7475":"346f93b0","8105":"3f4fc65e"}[chunkId] + ".chunk.css";
};